<template>
  <tr>
    <td>
      {{ nport.location }}
    </td>
    <td>
      {{ nport.serial }}
    </td>
    <td>
      {{ nport.ipAddress }}
    </td>
    <td>
      {{ nport.port }}
    </td>
    <td>
      {{ nport.version }}
    </td>
    <td>
      <span class="fa" :class="{
        'fa-check text-success': nport.mainNPort,
        'fa-times text-danger': !nport.mainNPort
      }"></span>
    </td>
    <td>
      <router-link class="btn btn-sm btn-primary" :to="'/hardware/nports/edit/' + nport.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
  </tr>
</template>

<script>
import CheckboxInput from '@/components/inputs/CheckboxInput'

export default {
  components: {
    CheckboxInput
  },
  name: 'NPortRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    nport () {
      return {
        ...this.object,
        ...this.updatedNPort
      }
    }
  },
  data () {
    return {
      updatedNPort: {}
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/NPort.vue